// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';
import {twMerge} from 'tailwind-merge';

import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsDrawerSectionOverrides} from './MediaSettingsDrawerSectionOverrides';
import {Subsettings} from './MediaSettingsDrawerSectionSubsettings';
import {MediaSettingsSection} from './types';

export const MediaSettingsDrawerSection = ({
  title,
  settings,
}: MediaSettingsSection) => {
  const [isOpen, setIsOpen] = useState(true);
  const {config, numberOfOverridesBelow, clearOverridesBelow} =
    useMediaSettingsDrawerContext();

  return (
    <>
      <div className="mt-0 flex flex-col first:mt-4">
        <div
          className="my-12 flex h-32 cursor-pointer items-center justify-between text-moon-500 hover:text-moon-650 dark:hover:text-moon-350"
          onClick={() => setIsOpen(!isOpen)}>
          <div className="text-[15px] font-semibold uppercase tracking-wide">
            {title}
          </div>
          <Button
            data-test={`media-settings-drawer-section-toggle-${title}`}
            icon={isOpen ? 'chevron-up' : 'chevron-down'}
            variant="ghost"
            size="small"
          />
        </div>
        {isOpen && (
          <div data-test={`media-settings-drawer-section-${title}`}>
            {settings.map(
              (
                {
                  component: SettingComponent,
                  getComponentKey,
                  configKey,
                  subsettings,
                },
                index
              ) => (
                <div
                  key={`${title}-${index}-${getComponentKey?.(config) ?? ''}`}
                  className="flex flex-col gap-8 pt-16 first:pt-0">
                  <SettingComponent />
                  {config[configKey] != null && (
                    <MediaSettingsDrawerSectionOverrides
                      configKey={configKey}
                      numberOfOverridesBelow={numberOfOverridesBelow}
                      clearOverridesBelow={clearOverridesBelow}
                    />
                  )}
                  {subsettings && config[configKey] != null && (
                    <Subsettings subsettings={subsettings} />
                  )}
                </div>
              )
            )}
          </div>
        )}
      </div>
      <div
        role="separator"
        className={twMerge('h-px bg-moon-250', isOpen && 'mt-16')}
      />
    </>
  );
};
